@if (layoutService.isConfigPanelOpen()) {
    <!-- Config panel — #panel reference used by ViewChild for outside click detection -->
    <div
        #panel
        class="config-panel fixed top-[64px] right-0 w-[240px] bg-[var(--surface-overlay)] border border-[var(--surface-border)] shadow-xl rounded-bl-xl z-80 p-4 flex flex-col gap-4 animate-slide-in"
    >
        <!-- ===== PRIMARY COLORS ===== -->
        <div>
            <p
                class="text-xs font-semibold text-[var(--text-color-secondary)] uppercase tracking-widest mb-2"
            >
                Primary
            </p>
            <div class="flex flex-wrap gap-1.5">
                @for (color of primaryColors; track color.name) {
                    <!-- Color swatch button — highlights if currently selected -->
                    <button
                        type="button"
                        class="w-6 h-6 rounded-full border-2 transition-all duration-150 hover:scale-110 focus:outline-none"
                        [style.background-color]="color.value"
                        [style.box-shadow]="'0 0 0 1px rgba(255,255,255,0.3)'"
                        [ngClass]="
                            currentPrimary === color.name
                                ? 'border-white ring-2 ring-offset-1 ring-[var(--primary-color)] scale-110'
                                : 'border-transparent'
                        "
                        [attr.aria-label]="color.name"
                        (click)="selectPrimary(color.name)"
                    ></button>
                }
            </div>
        </div>

        <!-- ===== SURFACE COLORS ===== -->
        <div>
            <p
                class="text-xs font-semibold text-[var(--text-color-secondary)] uppercase tracking-widest mb-2"
            >
                Surface
            </p>
            <div class="flex flex-wrap gap-1.5">
                @for (color of surfaceColors; track color.name) {
                    <!-- Surface swatch button — highlights if currently selected -->
                    <button
                        type="button"
                        class="w-6 h-6 rounded-full border-2 transition-all duration-150 hover:scale-110 focus:outline-none"
                        [style.background-color]="color.value"
                        [style.box-shadow]="'0 0 0 1px rgba(255,255,255,0.3)'"
                        [ngClass]="
                            currentSurface === color.name
                                ? 'border-white ring-2 ring-offset-1 ring-[var(--primary-color)] scale-110'
                                : 'border-transparent'
                        "
                        [attr.aria-label]="color.name"
                        (click)="selectSurface(color.name)"
                    ></button>
                }
            </div>
        </div>
    </div>
}
